import DiscreetModal, { DiscreetModalProps } from './DiscreetModal';

export default DiscreetModal;

export type { DiscreetModalProps };
